module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_f_normal.8fea0284.png";